const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  convertT2S ({ state, commit, rootState }, params) {
    return rootState.axios.post('/option/v1frontend/opencc/convert-t2s', params)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
